import { GridRowHeightParams } from '@/global/components/DataGrid/utils/types'
import { LogCalculos } from '@/service/api'
import { match, P } from 'ts-pattern'

export function getDigitacaoRowHeight({ row, density }: GridRowHeightParams) {
    const densityFactor = match(density)
        .with('compact', () => 0.75)
        .with('comfortable', () => 1.25)
        .otherwise(() => 1)

    return match<number>(row.registros.length)
        .with(P.number.between(17, 24), () => 208 * densityFactor + 10)
        .with(P.number.between(11, 16), () => 156 * densityFactor + 10)
        .with(P.number.between(5, 10), () => 104 * densityFactor + 10)
        .otherwise(() => 52 * densityFactor + 10)
}

export function getDigitacaoRowClassName({ row }: { row: any }) {
    if (row.logs?.length) {
        if (row.logs.some((log: LogCalculos) => log.variante === 'error'))
            return 'row-error'
        if (row.logs.some((log: LogCalculos) => log.variante === 'warning'))
            return 'row-warning'
        if (row.logs.some((log: LogCalculos) => log.titulo === 'Rescisão'))
            return 'row-attention'
        if (row.logs.some((log: LogCalculos) => log.variante === 'info'))
            return 'row-info'
        if (row.logs.some((log: LogCalculos) => log.variante === 'success'))
            return 'row-success'
    } else if (row.feriado) return 'row-info'

    return ''
}
